import React, { useEffect,useState }  from 'react';
import ScrollView from '../ScrolllView'
import styles from  "./index.module.css";
const ACTIVITYLIST = [
  {
    time:'07:00-07:30',
    name:'早晨慢跑',
    type:'活动'
  },
  {
    time:'08:00-08:30',
    name:'居家助洁',
    type:'服务'
  },
  {
    time:'10:00-10:40',
    name:'肩颈肩周调理',
    type:'服务'
  },
  {
    time:'12:30-12:40',
    name:'餐后血糖监测',
    type:'服务'
  },
  {
    time:'14:00-14:40',
    name:'软笔书法基础课',
    type:'老年大学'
  },
  {
    time:'19:00-19:30',
    name:'晚间照护',
    type:'服务'
  },
]

const HEALTHDES = [
  "规律作息：尽量保持每天固定的起床和睡觉时间，帮助调整生物钟，提高睡眠质量。",
  "多样化饮食：尽量摄入多种颜色的蔬菜和水果，它们富含不同的维生素和矿物质，有助于维持身体健康。",
  "坚持吃早餐：早餐是一天中最重要的一餐，提供身体所需的能量和营养，有助于维持血糖稳定和提高工作效率。",
  "控制屏幕时间：减少长时间盯着电脑、手机等屏幕的时间，定期休息眼睛，避免眼部疲劳和视力下降。 ",
  "适度晒太阳：每天适度晒太阳有助于补充维生素D，但注意避免中午时分强烈的阳光，以免晒伤。",
  "勤洗手：经常用肥皂和清水洗手，特别是在接触公共场所或交通工具后，有助于预防病菌传播。", 
  "定期体检：定期进行全面体检，及时发现并处理潜在的健康问题，预防疾病的发生。"
]
function Schedule() {
  const [tip,setTip] = useState(HEALTHDES[0]);
  useEffect(() =>{
    const timer = setInterval(() =>{
      const key = HEALTHDES.indexOf(tip);
      let word = "";
      if(key == HEALTHDES?.length -1){
        word = HEALTHDES[0]
      }else{
        word = HEALTHDES[key+1]
      }
      setTip(word)
    },1000*60);
    return () =>{
      clearInterval(timer);
    }
  })
  const renderChildren = () =>{
    return (
      ACTIVITYLIST?.map((item,index) =>{
        return (
          <div key={index} className={styles['activity-item']} >
            <div className={styles['activity-time']} >
              <span style={{paddingRight:24}} >·</span>
              {item.time}
            </div>
            <div className={styles['activity-name']} >
              {item.name}
            </div>
          <div className={[styles['activity-type'],item.type === '活动' && styles['activity-type-1'] ,item.type === '服务' && styles['activity-type-2'],item.type === '老年大学' && styles['activity-type-3']].join(' ')} >
              {item.type}  
            </div>
          </div>
        )
      })
    )
  }    
  return (
    <div className={styles['schedule-container']} >
      <div className={styles['activity-container']}>
        <div className={styles['title']} >
          今日待办
        </div>
        <div className={styles['activity-content']} >
          <ScrollView 
              isNoseToTail 
              children={renderChildren()} 
              listLength={ACTIVITYLIST?.length}
              viewHeight={408} 
              itemHeight={102} 
              speed={0.5} 
          />
         
        </div>
      </div>
      <div className={styles['health-container']}>
        <div className={styles['title']} >
        健康贴士
        </div>
        <div className={styles['health-des']} >
          {
            tip
          }
        </div>
      </div>  
    </div>
    
  );
}

export default Schedule;